export enum EAuctionLotLabel {
    'OnFarmHybrid' = 0,
    'HundredPercentOnline' = 1,
    'Saleyard' = 2,
}
